import { Button } from '@mui/material'
import { useTranslation } from 'react-i18next'

const PromotionsMenu = () => {
  const { t } = useTranslation()
  return (
    <div>
      <Button id="btnPromotions" href="/promotions">
        {t('common.promotions')}
      </Button>
    </div>
  )
}
export default PromotionsMenu
